import React from 'react';
import cs from 'classnames';

import {formatTimeDuration, gradeAge} from '~/misc/dates';

import css from './index.css';

const AgeLabel = ({properAge, deleted, viewed, className}) => {
  const ageGrade = gradeAge(properAge);
  const title = formatTimeDuration(properAge);
  return (
    <span className={cs(css.ageLabel, {
      [css.ageFresh]: ageGrade === 'fresh',
      [css.ageOk]: ageGrade === 'ok',
      [css.ageOld]: ageGrade === 'old',
      [css.ageLabelRemoved]: deleted,
      [css.ageRowViewed]: viewed,
    }, className)}
      data-qa={'search-result-age'}
      title={title}
    >
      {deleted ? '—' : title}
    </span>
  );
};

export default AgeLabel;



// WEBPACK FOOTER //
// ./src/components/AgeLabel/index.js